import { render, staticRenderFns } from "./OccurrenceOutcomeModal.vue?vue&type=template&id=06d9a1bb"
import script from "./OccurrenceOutcomeModal.vue?vue&type=script&lang=js"
export * from "./OccurrenceOutcomeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports